import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import DatePicker from 'react-datepicker';
import { IconRightDecorator } from '../../../../components/Icon/IconRightDecorator';
import { Calendar } from '../../../../components/Icon';
import dayjs from 'dayjs';
import cn from 'classnames';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import styled from 'styled-components';
import { setNewInvoiceValue } from '../../actions';
import { selectNewInvoice, selectNewInvoiceValue } from '../../selectors';
import { Dropdown } from '../../../../components/Dropdown';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { Loader } from '../../../../components/Loader';
import { Row, Cell } from '../../../../components/List';
import { VehicleCreateFieldCompany } from '../../../Vehicles/pages/create/FieldCompany';
import { calculatePurchasePriceInclVatExclBPM, calculatePurchasePricesMARGE } from '../../../Vehicles/actions';
import { calculatePurchasePricesBTW } from '../../../Vehicles/actions';
import { BtwOrMarge } from '../../constants';
import { Permission } from '../../../../components/Permission';
import {
  COMPANY_EDIT_IBAN,
  COMPANY_EDIT_CUSTOMERNUMBER,
  COMPANY_EDIT_BTW_NUMBER,
} from '../../../../components/Permission/constants';
import { Warnings } from '../../../Api/Warnings';
import { OnMouseOverNotification } from '../../../Vehicles/components/OnMouseOverNotification';
import styles from './FieldsPurchase.module.css';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalculator } from '@fortawesome/free-solid-svg-icons';
import { SearchSelect } from '../../../../components/SearchSelectComponent';

dayjs.extend(customParseFormat);

const DROPDOWN_OPTIONS = {
  btwOrMarge: ['BTW', 'marge'],
  vehiclePurpose: ['passenger', 'commercial'],
  vat_code: [],
};

const STATE = {
  value: '',
};

const Container = styled.div`
  width: 200px;
  .button-calc {
    &.button {
      margin: 0;
    }
  }
`;

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 24px;
  color: red;
`;

const CreditorContainer = styled.div`
  max-width: 200px;
  white-space: break-spaces;
`;

/* eslint-disable react/prefer-stateless-function */
class PurchaseFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    if (!this.props.value || this.props.values?.id != this.props.match.params?.id) {
      this.setInitialValue(this.props.type);
    }

    if (this.props.type == 'financialTotalAmount') {
      let sum = +this.props.invoice?.[this.props.type] + +this.props.extraTotalAmount;
      this.props.setValue(sum, this.props.type);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.type == 'financialTotalAmount' && prevProps.extraTotalAmount !== this.props.extraTotalAmount) {
      let sum = +this.props.invoice?.[this.props.type] + +this.props.extraTotalAmount;
      this.props.setValue(sum, this.props.type);
    }
  }

  setInitialValue(type) {
    if (
      type == 'financial_purchase_price_excl_vat_excl_bpm' ||
      type == 'rest_bpm' ||
      type == 'financial_bpm_gross' ||
      type == 'financial_purchase_price_incl_vat_bpm' ||
      type == 'financial_purchase_price_incl_vat_excl_bpm' ||
      type == 'financial_purchase_price_marge_excl_bpm' ||
      type == 'financial_purchase_price_marge_bpm'
    ) {
      // return this.props.setValue(this.props.vehicle?.financialAmounts[type], type);
      return this.props.setValue(this.props?.vehicleSubject?.[type], type);
    }

    if (type == 'vat_amount') {
      return this.props.setValue(this.props?.vehicleSubject?.['subjectVat']['amount'], type);
    }

    if (type === 'buyingCompany') {
      return this.props.setValue(this.props.vehicle?.buyingCompany?.id, type);
    }
    if (type == 'vehiclePurpose' || type == 'btwOrMarge') {
      if (!this.props.vehicle) {
        return;
      }
      return this.props.setValue(this.props.vehicle?.[type], type);
    }

    if (type == 'referenceNumber' || type == 'paidDate' || type == 'entryNumber' || type == 'date') {
      return this.props.setValue(this.props.invoice?.[type], type);
    }

    if (type == 'vatCode') {
      return this.props.setValue(this.props.vehicleSubject?.subjectVat?.code, type);
    }

    if (type == 'BTW_number' || type == 'IBAN' || type == 'customernumber') {
      return;
    }

    return this.props.setValue(this.props.vehicle?.buyingCompany?.[type], type);
  }

  isDropbox() {
    return this.props.type in DROPDOWN_OPTIONS;
  }

  isDate() {
    return ['date', 'paidDate'].indexOf(this.props.type) > -1;
  }

  wrap(children) {
    switch (this.props.type) {
      default:
        return (
          <Row key={this.props.type}>
            <Cell>{this.formFieldLabel()}</Cell>
            <Cell className={this.props.type == 'vatCode' && 'field-cell'}>
              {this.props.type !== 'vatCode' ? <FormField>{children}</FormField> : <Container>{children}</Container>}
            </Cell>
          </Row>
        );
    }
  }

  formFieldLabel() {
    return this.lbl(`invoice.details.${this.props.type}`);
  }

  dropdown() {
    DROPDOWN_OPTIONS['vatCode'] = [...this.props.options];
    const vals = DROPDOWN_OPTIONS[this.props.type];

    let options = vals.map(val => ({
      label: this.lbl(`invoice.details.${this.props.type}.${val}`),
      value: val,
    }));

    if (this.props.type == 'vatCode') {
      options = vals.map(val => ({
        label: val?.label,
        value: val?.value,
      }));
    }

    const value = options.find(o => o.value == this.props.value);

    return (
      <Container>
        <SearchSelect
          options={options}
          value={value}
          onChange={pair => {
            if (this.props.type == 'btwOrMarge' && pair.value == 'marge') {
              this.props.setValue(null, 'vatCode');
              this.props.setValue(null, 'vat_amount');
            }
            this.props.setValue(pair.value);
            this.calculatePurchasePrice();
          }}
        />
        {this.requireMessage && !this.props.value ? <RequireMark>*</RequireMark> : null}
      </Container>
    );
  }

  datePicker() {
    let format = this.props.value == '-' ? 'DD-MM-YYYY' : undefined;

    let selected = this.props.value && dayjs(this.props.value, format);
    return (
      <div className={cn('d-flex align-items-baseline', styles.containerDatePicker)}>
        <DatePicker
          dateFormat="dd-MM-yyyy"
          selected={selected && selected.toDate()}
          onChange={date => {
            let d = dayjs(date).format('YYYY-MM-DD hh:mm:ss');
            this.props.setValue(d);
          }}
        />
        <Calendar className={styles.iconCalendar} />
      </div>
    );
  }

  reset() {
    this.setState({ ...STATE });
  }

  get requireMessage() {
    return this.props.isRequire?.includes(this.props.type);
  }

  onChangePurchasePricesData() {
    this.calculatePurchasePrice();
  }

  onChangeInputPurchasePrice(evt) {
    this.props.type == 'financial_purchase_price_incl_vat_bpm'
      ? this.props.setValue(evt.target.value)
      : this.props.setValue(evt);
    this._t = this.timeout(this.calculatePurchasePrices.bind(this), 300, this._t);
  }

  calculatePurchasePrice() {
    let priceField = 'financial_purchase_price_excl_vat_excl_bpm';
    let value = 0;
    if (!this.props.values['financial_purchase_price_excl_vat_excl_bpm']) {
      // this.props.setValue('', 'financial_purchase_price_incl_vat_excl_bpm');
    }

    if (
      this.props.type == 'financial_purchase_price_incl_vat_excl_bpm' ||
      this.props.type == 'financial_purchase_price_incl_vat_bpm'
    ) {
      priceField = 'financial_purchase_price_incl_vat_bpm';
    }

    if (this.props.type == 'financial_purchase_price_excl_vat_excl_bpm') {
      value = this.props.values?.financial_purchase_price_excl_vat_excl_bpm;
    }
    if (this.props.type == 'financial_purchase_price_incl_vat_excl_bpm') {
      value = this.props.values?.financial_purchase_price_incl_vat_excl_bpm + +this.props.values?.rest_bpm;
    }
    if (this.props.type == 'financial_purchase_price_incl_vat_bpm') {
      value = this.props.values?.financial_purchase_price_incl_vat_bpm;
    }

    if (this.props.type == 'vatCode') {
      value = this.props.values?.financial_purchase_price_excl_vat_excl_bpm;
    }

    const dto = {
      source: this.props.values?.company_from_eu,
      btwOrMarge: this.props.values?.btwOrMarge,
      vehiclePurpose: this.props.values?.vehiclePurpose,
      isImported: this.props.values?.import === '1',
      buyerType: this.props.invoice?.vehicle?.creditorCompany?.type,
      vatCodeNumber: this.props.values?.vatCode,
      rest_bpm:
        typeof this.props.values?.rest_bpm == 'string'
          ? parseFloat(this.props.values?.rest_bpm?.replace(',', '.'))
          : +this.props.values?.rest_bpm,
    };

    const re = new RegExp(/^\d+(\.\d{1,2})?$/);

    if (priceField) dto[priceField] = typeof value == 'string' ? parseFloat(value?.replace(',', '.')) : +value;

    if (!re.test(dto[priceField])) {
      return <Warnings message={`${priceField} should be a number`} hideWarning={this.props.reset} />;
    }

    if (this.props.type == 'rest_bpm') {
      dto.financial_purchase_price_incl_vat_bpm = +this.props.values?.financial_purchase_price_incl_vat_bpm || 0;
      dto.financial_purchase_price_excl_vat_excl_bpm = +this.props.values?.financial_purchase_price_excl_vat_excl_bpm || 0;
      dto.financial_purchase_price_incl_vat_excl_bpm = +this.props.values?.financial_purchase_price_incl_vat_excl_bpm || 0;
    }

    this.props.calculatePurchasePrices(dto, result => {
      if (result) {
        this.props.setValue(
          result?.financial_purchase_price_incl_vat_excl_bpm,
          'financial_purchase_price_incl_vat_excl_bpm',
        );
        this.props.setValue(
          result?.financial_purchase_price_excl_vat_excl_bpm,
          'financial_purchase_price_excl_vat_excl_bpm',
        );
        this.props.setValue(result?.vat_amount, 'vat_amount');
        this.props.setValue(result?.financial_purchase_price_incl_vat_bpm, 'financial_purchase_price_incl_vat_bpm');
        this.props.setValue(
          result?.financial_purchase_price_excl_vat_excl_bpm,
          'financial_purchase_price_excl_vat_excl_bpm',
        );
      }
    });

    this.props.setValue(true, 'isAvailable');
  }

  onChangePurchasePricesMarge() {
    this._t = this.timeout(this.calculatePurchasePriceMarge.bind(this), 1500, this._t);
  }

  calculatePurchasePriceMarge() {
    const priceField =
      this.props.values?.import == '1' || this.props.values?.import === true
        ? 'financial_purchase_price_marge_excl_bpm'
        : 'financial_purchase_price_marge_bpm';
    const dto = {
      rest_bpm:
        typeof this.props.rest_bpm == 'string' ? parseFloat(this.props.rest_bpm?.replace(',', '.')) : +this.props.rest_bpm,
      [priceField]:
        typeof this.props.values[priceField] == 'string'
          ? parseFloat(this.props.values[priceField].replace(',', '.')) || 0
          : +this.props.values[priceField] || 0,
    };
    this.props.calculatePurchasePriceMarge(dto, result => {
      if (result) {
        this.props.setValue(result?.price, 'tempMargePrice');
        this.props.setValue(result?.financial_purchase_price_marge_bpm, 'financial_purchase_price_marge_bpm');
        this.props.setValue(result?.financial_purchase_price_marge_excl_bpm, 'financial_purchase_price_marge_excl_bpm');
        this.props.setValue(result?.vat_amount, 'vat_amount');
        this.props.setValue(result?.financial_purchase_price_incl_vat_bpm, 'financial_purchase_price_incl_vat_bpm');
      }
    });

    this.props.setValue(true, 'isAvailable');
  }

  calculatePurchasePrices() {
    if (this.props.values?.btwOrMarge === BtwOrMarge.BTW) {
      this.props.calculatePurchasePricesBTW(
        {
          financial_purchase_price_incl_vat_bpm: _.toNumber(this.props.values?.financial_purchase_price_incl_vat_bpm),
          rest_bpm:
            typeof this.props.values?.rest_bpm == 'string'
              ? parseFloat(this.props.values?.rest_bpm?.replace(',', '.'))
              : +this.props.values?.rest_bpm,
        },

        result => {
          this.props.setValue(
            result.financial_purchase_price_excl_vat_excl_bpm,
            'financial_purchase_price_excl_vat_excl_bpm',
          );
          this.props.setValue(result.vat_amount, 'vat_amount');
        },
      );
    }
  }

  render() {
    if (this.props.work) return <Loader small />;
    return <>{this.wrap(this.renderField())}</>;
  }

  renderField() {
    if (this.isDropbox()) {
      return this.dropdown();
    }

    if (this.isDate()) {
      return this.datePicker();
    }

    switch (this.props.type) {
      case 'IBAN':
        return (
          <Permission permission={COMPANY_EDIT_IBAN} proxy={this.props.value ?? '-'}>
            <input
              className="form-control"
              name="IBAN"
              value={this.props.value || ''}
              onChange={evt => this.props.setValue(evt.target.value)}
            />
          </Permission>
        );

      case 'BTW_number':
        return (
          <Permission permission={COMPANY_EDIT_BTW_NUMBER} proxy={this.props.value ?? '-'}>
            <input
              className="form-control"
              name="BTW_number"
              value={this.props.value}
              onChange={evt => this.props.setValue(evt.target.value)}
            />
          </Permission>
        );

      case 'customernumber':
        return (
          <Permission permission={COMPANY_EDIT_CUSTOMERNUMBER} proxy={this.props.value ?? '-'}>
            <input
              className="form-control"
              name="customernumber"
              value={this.props.value || ''}
              onChange={evt => this.props.setValue(evt.target.value)}
            />
          </Permission>
        );
      case 'creditor_company':
        return (
          <CreditorContainer>
            <VehicleCreateFieldCompany
              disabled={true}
              selectedCompanyId={this.props.invoice?.incomingCompany?.id}
              key={this.props.type}
              type={this.props.type}
              onChange={value => this.props.setValue(value)}
            />
          </CreditorContainer>
        );
      case 'referenceNumber':
        return (
          <>
            <input
              className="form-control"
              name="referenceNumber"
              value={this.props.value || ''}
              onChange={evt => this.props.setValue(evt.target.value)}
            />
            {this.requireMessage && !this.props.value ? <RequireMark>*</RequireMark> : null}
          </>
        );

      case 'entryNumber':
        return (
          <>
            <input
              className="form-control"
              disabled
              name="entryNumber"
              value={this.props.value || ''}
              onChange={evt => this.props.setValue(evt.target.value)}
            />
            {this.requireMessage && !this.props.value ? <RequireMark>*</RequireMark> : null}
          </>
        );
      case 'financialTotalAmount':
        return (
          <>
            <input
              className="form-control"
              disabled={true}
              name="financialTotalAmount"
              value={this.props.value || ''}
              onChange={evt => this.props.setValue(evt.target.value)}
            />
            {this.requireMessage && !this.props.value ? <RequireMark>*</RequireMark> : null}
          </>
        );
      case 'financial_purchase_price_excl_vat_excl_bpm':
        const financial_purchase_price_excl_vat_excl_bpm_is_disable =
          (this.props.values?.import === '0' || this.props.values?.import === false) &&
          this.props.values?.btwOrMarge == BtwOrMarge.BTW &&
          this.props.values?.vehiclePurpose == 'passenger';

        return (
          <>
            <div className={styles.inputButton}>
              <input
                className="form-control"
                disabled={financial_purchase_price_excl_vat_excl_bpm_is_disable}
                name="financial_purchase_price_excl_vat_excl_bpm"
                value={this.props.value || ''}
                onChange={evt => {
                  this.props.setValue(evt.target.value);
                  this.props.setValue(false, 'isAvailable');
                }}
              />
              {!financial_purchase_price_excl_vat_excl_bpm_is_disable && (
                <div style={{ width: '70px' }}>
                  <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.onChangePurchasePricesData.bind(this)}>
                    <FontAwesomeIcon icon={faCalculator} size="lg" />
                  </ButtonComponent>
                </div>
              )}
            </div>
            {this.requireMessage && !this.props.value ? <RequireMark>*</RequireMark> : null}
          </>
        );
      case 'rest_bpm':
        return (
          <>
            {this.props.vehicle?.taxiVerleden == '1' && (
              <OnMouseOverNotification message={this.lbl('alert.is_taxi_tax_message')} />
            )}
            <div className={styles.inputButton}>
              <input
                className="form-control"
                name="rest_bpm"
                value={this.props.value || ''}
                // onChange={evt => this.props.setValue(evt.target.value)}
                // onChange={this.onChangePurchasePricesData.bind(this)}
                onChange={evt => {
                  this.props.setValue(evt.target.value);
                  this.props.setValue(false, 'isAvailable');
                }}
              />
              <div style={{ width: '70px' }}>
                <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.onChangePurchasePricesData.bind(this)}>
                  <FontAwesomeIcon icon={faCalculator} size="lg" />
                </ButtonComponent>
              </div>
            </div>
            {this.requireMessage && !this.props.value ? <RequireMark>*</RequireMark> : null}
          </>
        );
      case 'financial_bpm_gross':
        return (
          <>
            <input
              className="form-control"
              name="financial_bpm_gross"
              value={this.props.value || ''}
              onChange={evt => {
                this.props.setValue(evt.target.value);
                this.props.setValue(false, 'isAvailable');
              }}
            />
            {this.requireMessage && !this.props.value ? <RequireMark>*</RequireMark> : null}
          </>
        );
      case 'vat_amount':
        return (
          <>
            <input
              className="form-control"
              disabled={true}
              name="vat_amount"
              value={this.props.value || ''}
              onChange={evt => this.props.setValue(evt.target.value)}
            />
            {this.requireMessage && !this.props.value ? <RequireMark>*</RequireMark> : null}
          </>
        );
      case 'financial_purchase_price_incl_vat_bpm':
        const financial_purchase_price_incl_vat_bpm_is_disable =
          (this.props.values?.import === '1' || this.props.values?.import === true) &&
          this.props.values?.btwOrMarge == BtwOrMarge.BTW;
        return (
          <>
            <div className={styles.inputButton}>
              <input
                className="form-control"
                disabled={financial_purchase_price_incl_vat_bpm_is_disable}
                name="financial_purchase_price_incl_vat_bpm"
                value={this.props.value || ''}
                // onChange={evt => this.props.setValue(evt.target.value)}
                onChange={evt => {
                  this.props.setValue(evt.target.value);
                  this.props.setValue(false, 'isAvailable');
                }}
                // onChange={this.onChangePurchasePricesData.bind(this)}
              />
              {!financial_purchase_price_incl_vat_bpm_is_disable && (
                <div style={{ width: '70px' }}>
                  <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.onChangePurchasePricesData.bind(this)}>
                    <FontAwesomeIcon icon={faCalculator} size="lg" />
                  </ButtonComponent>
                </div>
              )}
            </div>
            {this.requireMessage && !this.props.value ? <RequireMark>*</RequireMark> : null}
          </>
        );
      case 'financial_price_b2c':
        return (
          <input
            className="form-control"
            value={this.props.value || ''}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'financial_purchase_price_incl_vat_excl_bpm':
        const financial_purchase_price_incl_vat_excl_bpm_is_disable =
          (this.props.values?.import === '1' || this.props.values?.import === true) &&
          this.props.values?.btwOrMarge == BtwOrMarge.BTW;
        return (
          <>
            <div className={styles.inputButton}>
              <input
                className="form-control"
                // disabled={true}
                disabled={financial_purchase_price_incl_vat_excl_bpm_is_disable}
                value={this.props.value || ''}
                onChange={evt => {
                  this.props.setValue(evt.target.value);
                  this.props.setValue(false, 'isAvailable');
                }}
                // onChange={evt => this.props.setValue(evt.target.value)}
              />
              {!financial_purchase_price_incl_vat_excl_bpm_is_disable && (
                <div style={{ width: '70px' }}>
                  <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.onChangePurchasePricesData.bind(this)}>
                    <FontAwesomeIcon icon={faCalculator} size="lg" />
                  </ButtonComponent>
                </div>
              )}
            </div>
            {this.requireMessage && !this.props.value ? <RequireMark>*</RequireMark> : null}
          </>
        );
      case 'financial_purchase_price_marge_bpm':
        return (
          <>
            <div className={styles.inputButton}>
              <input
                className="form-control"
                value={this.props.value || ''}
                // onChange={evt => this.props.setValue(evt.target.value)}
                onChange={evt => {
                  this.props.setValue(evt.target.value);
                  this.props.setValue(false, 'isAvailable');
                }}
              />

              <div style={{ width: '70px' }}>
                <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.onChangePurchasePricesMarge.bind(this)}>
                  <FontAwesomeIcon icon={faCalculator} size="lg" />
                </ButtonComponent>
              </div>
            </div>
            {this.requireMessage && !this.props.value ? <RequireMark>*</RequireMark> : null}
          </>
        );
      case 'financial_price_b2b_incl_vat_btpm':
        return (
          <>
            <div className={styles.inputButton}>
              <input
                className="form-control"
                value={this.props.value || ''}
                onChange={evt => {
                  this.props.setValue(evt.target.value);
                  this.props.setValue(false, 'isAvailable');
                }}
                // onChange={this.onChangePurchasePricesData.bind(this)}
              />

              <div style={{ width: '70px' }}>
                <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.onChangePurchasePricesMarge.bind(this)}>
                  <FontAwesomeIcon icon={faCalculator} size="lg" />
                </ButtonComponent>
              </div>
            </div>
            {this.requireMessage && !this.props.value ? <RequireMark>*</RequireMark> : null}
          </>
        );

      case 'financial_purchase_price_marge_excl_bpm':
        return (
          <>
            <input
              className="form-control"
              value={this.props.value || ''}
              // onChange={this.onChangePurchasePricesMarge.bind(this)}
              onChange={evt => {
                this.props.setValue(evt.target.value);
                this.props.setValue(false, 'isAvailable');
              }}
            />{' '}
            <div style={{ width: '70px' }}>
              <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.onChangePurchasePricesMarge.bind(this)}>
                <FontAwesomeIcon icon={faCalculator} size="lg" />
              </ButtonComponent>
            </div>
            {this.requireMessage && !this.props.value ? <RequireMark>*</RequireMark> : null}
          </>
        );
    }
  }
}

PurchaseFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    value: selectNewInvoiceValue(ownProps.type),
    values: selectNewInvoice(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewInvoiceValue(name, value));
    },
    calculatePurchasePrices(enteredAmounts, callback) {
      dispatch(calculatePurchasePriceInclVatExclBPM(enteredAmounts, callback));
    },
    calculatePurchasePriceMarge(enteredAmounts, callback) {
      dispatch(calculatePurchasePricesMARGE(ownProps.vehicle?.id, enteredAmounts, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const PurchaseField = compose(withConnect, withRouter)(PurchaseFieldComp);
